import INTERNAL_INSTALLATION_IDS from '@/utils/constants/internalInstallationIds';

export default (installationId) => INTERNAL_INSTALLATION_IDS.includes(installationId);
